import { AfterViewInit, ApplicationRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl, SafeStyle } from '@angular/platform-browser';
import { AbstractWidgetComponent, ContextChange, WidgetStyle } from '@sdbn/common';
import { TerminalContextConstants } from '@sdbn/tmc-common';
import { DocumentScannerPreviewDialog } from './document-scanner-preview-dialog';

@Component({
    selector: 'app-transport-registration-document-scan',
    templateUrl: './transport-registration-document-scan.component.html',
    styleUrls: ['./transport-registration-document-scan.component.scss'],
    standalone: false
})
export class TransportRegistrationDocumentScanComponent extends AbstractWidgetComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('video', { static: false })
  public video: ElementRef;

  @ViewChild('canvas', { static: false })
  public canvas: ElementRef;

  private localStream: any;

  captures = [];

  private videoConstraints = {
    sd: { width: { ideal: 1024 }, height: { ideal: 768 } },
    hd: { width: { ideal: 1920 }, height: { ideal: 1080 } },
    fullHd: { width: { ideal: 2576 }, height: { ideal: 1932 } }
  };

  targetWidth = 1080;
  targetHeight = 1080;
  offsetLeft = -180;

  private selectedResolution = 'hd';
  resolution: any;

  constructor(
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private applicationRef: ApplicationRef
  ) {
    super();
    this.selectedResolution = 'hd';
    this.resolution = this.videoConstraints[this.selectedResolution];
  }

  ngOnInit(): void {
  }

  public ngAfterViewInit() {
    const width = this.resolution.width.ideal;
    const translate = this.offsetLeft - (width - this.targetWidth) / 4;
    this.video.nativeElement.style.transform = 'translateX(' + translate + 'px)'; //578
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ video: this.resolution }).then(stream => {
        this.localStream = stream;
        this.video.nativeElement.srcObject = stream;
        this.video.nativeElement.play();
      });
    }
  }

  public ngOnDestroy() {

    super.ngOnDestroy();

    if (this.video && this.video.nativeElement) {
      this.video.nativeElement.srcObject = null;
      this.video.nativeElement.pause();
    }
    if (this.localStream) {
      this.localStream.getTracks().map((val) => val.stop());
    }
  }

  onContextChange(contextChange: ContextChange) {
  }
  onSetElementAndContext() {
    this.captures = this.dashboardContext.getContextValue(TerminalContextConstants.captures) || [];
  }

  get previewTransform(): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle('scale(' + this.resolution.height.ideal / this.resolution.width.ideal + ')');
  }

  public previewCapture(capture): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(capture.data);
  }

  public capture() {
    // this.idleService.enabled = true;
    const width = this.resolution.width.ideal;
    const ctx = this.canvas.nativeElement.getContext('2d');

    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, this.targetWidth, this.targetHeight);
    //ctx.translate(this.offsetLeft, 0);
    ctx.rotate(0);
    ctx.scale(1, 1);
    const source = this.video.nativeElement;
    ctx.drawImage(source,
      (width - this.targetWidth - this.offsetLeft) / 2,
      0,
      this.targetWidth, this.targetHeight, 0, 0, this.targetWidth, this.targetHeight); //

    if (!HTMLCanvasElement.prototype.toBlob) {
      Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
        value: function (callback, type, quality) {
          const canvas = this;
          setTimeout(() => {
            const binStr = atob(canvas.toDataURL(type, quality).split(',')[1]);
            const len = binStr.length;
            const arr = new Uint8Array(len);

            for (let i = 0; i < len; i++) {
              arr[i] = binStr.charCodeAt(i);
            }

            callback(new Blob([arr], { type: type || 'image/png' }));
          });
        }
      });
    }
    this.canvas.nativeElement.toBlob(blob => {
      setTimeout(() => {
        this.captures.push({
          blob,
          data: this.canvas.nativeElement.toDataURL('image/png')
        });
        this.dashboardContext.setContextValue(TerminalContextConstants.captures, this.captures);
        console.log('add capture', this.captures.length);
        // this.idleService.enabled = false;
        this.applicationRef.tick();
      })
    }, 'image/jpeg', 0.95); //quality
  }

  public openPreview(capture) {
    const dialogRef = this.dialog.open(DocumentScannerPreviewDialog);

    dialogRef.componentInstance.data = capture.data;
    dialogRef.componentInstance.deleteFunc = () => {
      this.deleteCapture(capture);
    };

    dialogRef.afterClosed()
      .subscribe(result => { });

    this.applicationRef.tick();
  }

  private deleteCapture(capture) {
    this.captures.splice(this.captures.indexOf(capture), 1);
    this.dashboardContext.setContextValue(TerminalContextConstants.captures, this.captures);
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
